import {DecimalPipe} from '@angular/common';
import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Market, TimecardRateType} from '../../model';

@Pipe({name: 'timecardHoursFormat'})
export class TimecardHoursFormatPipe implements PipeTransform {

  constructor(private Translate: TranslateService,
              private NumberPipe: DecimalPipe) {
  }

  transform(timecard: Timecard | TimecardDetails, val: string | number): string {
    let hours = 0;
    if (typeof val === 'string') {
      const split = val.split(':');
      hours = (+split[0]) + (+split[1] / 60);
    } else {
      hours = val;
    }
    switch (timecard.rateTypeId) {
      case TimecardRateType.DAILY:
        const hoursInDay = timecard.marketId === Market.Paris ? 7 : 8;
        return this.Translate.instant('timecards.days', {days: this.NumberPipe.transform((hours / hoursInDay), '1.1-1')});
      default:
        return this.Translate.instant('timecards.hours', {hours: this.NumberPipe.transform(hours, '1.2-2')});
    }
  }
}


